<style>
.table th,
.table td {
  padding-left: 5px !important;
  padding-top: 2px;
  padding-bottom: 2px;
}
</style>
<template>
  <section class="content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="card-header">
              <h3 class="card-title">Laporan Laba Rugi</h3>
            </div>

            <div class="card-body table-responsive p-2">
              <template>
                <div class="row">
                  <div class="col-sm-6">
                    <div class="form-group mb-0">
                      <MonthPicker v-model="filter.periode" label="Periode" @input="onFilterChange"
                        class="custom-input" />
                    </div>
                  </div>
                  <div class="col-sm-6">
                    <div class="form-group mb-0">
                      <KantorCabang v-model="filter.kantor" :multiple="true" label="Cabang" @input="onFilterChange"
                        class="custom-input" />
                    </div>
                  </div>
                </div>

              </template>
              <table class="table table-bordered mb-0">
                <tbody>
                  <tr class="font-bold">
                    <td colspan="2">Pendapatan</td>
                  </tr>

                  <tr v-for="kantor in kantorList" :key="'pi-' + kantor.id">
                    <td class="pl-6"><a href="#" style="color: black;"
                      @click="openModalDetail({ id: 1, item: 'Detail Item [Penjualan Paket Internet]', total: formatRupiah(findByValue('Pembayaran Invoice')),kantor_id : kantor.id })">
                      • Penjualan paket internet  {{ kantor.prefix }}</a>
                    </td>
                    <td class="text-right">
                      {{ formatRupiah(findByValue('Pembayaran Invoice', kantor.id)) }}
                    </td>
                  </tr>

                  <tr v-for="kantor in kantorList" :key="'pasang-' + kantor.id">
                    <td class="pl-6">
                      • Pemasangan baru & instalasi  {{ kantor.prefix }}
                    </td>
                    <td class="text-right">
                      {{ formatRupiah(findByValue('Pemasangan baru & instalasi', kantor.id)) }}
                    </td>
                  </tr>

                  <tr v-for="kantor in kantorList" :key="'lain-' + kantor.id">
                    <td class="pl-6">
                      • Pendapatan lain-lain  {{ kantor.prefix }}
                    </td>
                    <td class="text-right">
                      {{ formatRupiah(findByValue('Pendapatan lain-lain', kantor.id)) }}
                    </td>
                  </tr>

                  <tr class="bg-success text-white font-bold">
                    <td>Total Pendapatan</td>
                    <td class="text-right">
                      {{ formatRupiah(findByValue('Pembayaran Invoice')) }}
                    </td>
                  </tr>

                  <tr class="font-bold">
                    <td colspan="2">Beban Pokok Pendapatan</td>
                  </tr>
                  <tr v-for="kantor in kantorList" :key="'Bandwidth-' + kantor.id">
                    <td class="pl-6"><a href="#" style="color: black;"
                        @click="openModalDetail({ id: 19, item: 'Detail Item [Bandwidth Expense]', total: formatRupiah(findByValue('Bandwidth Expense')),kantor_id : kantor.id })">•
                        Bandwidth Expense {{ kantor.prefix }}</a></td>
                    <td class="text-right">{{ formatRupiah(findByValue('Bandwidth Expense', kantor.id)) }}</td>
                  </tr>
                  <tr v-for="kantor in kantorList" :key="'Equipment-' + kantor.id">
                    <td class="pl-6"><a href="#" style="color: black;"
                        @click="openModalDetail({ id: 18, item: 'Detail Item [Equipment]', total: formatRupiah(findByValue('Equipment')),kantor_id : kantor.id })">•
                        Equipment {{ kantor.prefix }}</a></td>
                    <td class="text-right">{{ formatRupiah(findByValue('Equipment', kantor.id)) }}</td>
                  </tr>
                  <tr class="bg-success text-white font-bold bg-opacity-75">
                    <td class="pl-6">Total Beban Pokok</td>
                    <td class="text-right">{{ formatRupiah(total.beban_pokok) }}</td>
                  </tr>

                  <tr class="bg-success text-white font-bold">
                    <td>Laba Kotor</td>
                    <td class="text-right">{{ formatRupiah(total.laba_kotor) }}</td>
                  </tr>

                  <tr class="font-bold">
                    <td colspan="2">Beban Operasional</td>
                  </tr>
                  <tr v-for="kantor in kantorList" :key="'Wage-' + kantor.id">
                    <td class="pl-6"><a href="#" style="color: black;"
                        @click="openModalDetail({ id: 20, item: 'Detail Item [Wage & Salary Expense]', total: formatRupiah(findByValue('Wage & Salary Expense')),kantor_id : kantor.id })">•
                        Wage & Salary Expense {{ kantor.prefix }}</a></td>
                    <td class="text-right">{{ formatRupiah(findByValue('Wage & Salary Expense', kantor.id)) }}</td>
                  </tr>
                  <tr v-for="kantor in kantorList" :key="'Operating-' + kantor.id">
                    <td class="pl-6"><a href="#" style="color: black;"
                        @click="openModalDetail({ id: 21, item: 'Detail Item [Operating Expense]', total: formatRupiah(findByValue('Operating Expense')),kantor_id : kantor.id })">•
                        Operating Expense {{ kantor.prefix }}</a></td>
                    <td class="text-right">{{ formatRupiah(findByValue('Operating Expense', kantor.id)) }}</td>
                  </tr>
                  <tr v-for="kantor in kantorList" :key="'fo-' + kantor.id">
                    <td class="pl-6"><a href="#" style="color: black;"
                        @click="openModalDetail({ id: 22, item: 'Detail Item [FO Dev Expense]', total: formatRupiah(findByValue('FO Dev Expense')),kantor_id : kantor.id })">•
                        FO Dev Expense {{ kantor.prefix }}</a></td>
                    <td class="text-right">{{ formatRupiah(findByValue('FO Dev Expense', kantor.id)) }}</td>
                  </tr>
                  <tr v-for="kantor in kantorList" :key="'Technical-' + kantor.id">
                    <td class="pl-6"><a href="#" style="color: black;"
                        @click="openModalDetail({ id: 23, item: 'Detail Item [Technical Support]', total: formatRupiah(findByValue('Technical Support')),kantor_id : kantor.id })">•
                        Technical Support {{ kantor.prefix }}</a></td>
                    <td class="text-right">{{ formatRupiah(findByValue('Technical Support', kantor.id)) }}</td>
                  </tr>
                  <tr v-for="kantor in kantorList" :key="'Maintenance-' + kantor.id">
                    <td class="pl-6"><a href="#" style="color: black;"
                        @click="openModalDetail({ id: 24, item: 'Detail Item [Maintenance Expense]', total: formatRupiah(findByValue('Maintenance Expense')),kantor_id : kantor.id })">•
                        Maintenance Expense {{ kantor.prefix }}</a></td>
                    <td class="text-right">{{ formatRupiah(findByValue('Maintenance Expense', kantor.id)) }}</td>
                  </tr>
                  <tr v-for="kantor in kantorList" :key="'Marketing-' + kantor.id">
                    <td class="pl-6"><a href="#" style="color: black;"
                        @click="openModalDetail({ id: 25, item: 'Detail Item [Marketing Fee]', total: formatRupiah(findByValue('Marketing Fee')),kantor_id : kantor.id })">•
                        Marketing Fee {{ kantor.prefix }}</a></td>
                    <td class="text-right">{{ formatRupiah(findByValue('Marketing Fee', kantor.id)) }}</td>
                  </tr>
                  <tr class="bg-success text-white font-bold bg-opacity-75">
                    <td class="pl-6">Total Beban Operasional</td>
                    <td class="text-right">{{ formatRupiah(total.beban_operasional) }}</td>
                  </tr>

                  <tr class="bg-success text-white font-bold">
                    <td>Laba Usaha</td>
                    <td class="text-right">{{ formatRupiah(total.laba_usaha) }}</td>
                  </tr>
                  <tr v-for="kantor in kantorList" :key="'Kredit-' + kantor.id">
                    <td class="pl-6"><a href="#" style="color: black;"
                        @click="openModalDetail({ id: 36, item: 'Detail Item [Kredit Bank]', total: formatRupiah(findByValue('Kredit Bank')),kantor_id : kantor.id })">•
                        Kredit Bank {{ kantor.prefix }}</a></td>
                    <td class="text-right">{{ formatRupiah(findByValue('Kredit Bank', kantor.id)) }}</td>
                  </tr>
                  <tr v-for="kantor in kantorList" :key="'Tax-' + kantor.id">
                    <td class="pl-6"><a href="#" style="color: black;"
                        @click="openModalDetail({ id: 36, item: 'Detail Item [Tax Expense]', total: formatRupiah(findByValue('Tax Expense')),kantor_id : kantor.id })">•
                        Tax Expense {{ kantor.prefix }}</a></td>
                    <td class="text-right">{{ formatRupiah(findByValue('Tax Expense', kantor.id)) }}</td>
                  </tr>
                  <tr v-for="kantor in kantorList" :key="'Zakat-' + kantor.id">
                    <td class="pl-6"><a href="#" style="color: black;"
                        @click="openModalDetail({ id: 36, item: 'Detail Item [Pembayaran Zakat]', total: formatRupiah(findByValue('Pembayaran Zakat')),kantor_id : kantor.id })">•
                        Pembayaran Zakat {{ kantor.prefix }}</a></td>
                    <td class="text-right">{{ formatRupiah(findByValue('Pembayaran Zakat', kantor.id)) }}</td>
                  </tr>
                  <tr v-for="kantor in kantorList" :key="'pph-' + kantor.id">
                    <td class="pl-6"><a href="#" style="color: black;"
                        @click="openModalDetail({ id: 36, item: 'Detail Item [Pajak penghasilan PPH 23]', total: formatRupiah(findByValue('Pajak penghasilan PPH 23')),kantor_id : kantor.id })">•
                        Pajak penghasilan PPH 23 {{ kantor.prefix }}</a></td>
                    <td class="text-right">{{ formatRupiah(findByValue('Pajak penghasilan PPH 23', kantor.id)) }}</td>
                  </tr>

                  <tr class="bg-success text-white font-bold">
                    <td>Laba Bersih</td>
                    <td class="text-right">{{ formatRupiah(total.laba_bersih) }}</td>
                  </tr>
                </tbody>
              </table>
            </div>

          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { formatRupiah } from '../../helpers/format'
import { EventBus } from '../../event-bus'
import ModalDetaiLabaRugi from './ModalDetaiLabaRugi.vue'
import MonthPicker from '../../base-components/MonthPicker.vue'
import KantorCabang from '../../base-components/KantorCabang.vue'
export default {
  components: {
    MonthPicker,
    KantorCabang,
  },
  data() {
    return {
      loading: false,
      laporan: [],
      filter: {
        periode: new Date().toISOString().slice(0, 7),
        kantor: []
      },
      total: {
        pendapatan: 0,
        beban_pokok: 0,
        laba_kotor: 0,
        beban_operasional: 0,
        laba_usaha: 0,
        laba_bersih: 0
      }
    }
  },
  computed: {
    // Buat daftar kantor unik dari data laporan (bukan dari filter)
    kantorList() {
      if (!Array.isArray(this.laporan)) return []
      const unique = {}
      this.laporan.forEach(item => {
        if (!unique[item.kantor_id]) {
          unique[item.kantor_id] = {
            id: item.kantor_id,
            prefix: item.prefix // ambil dari response JSON
          }
        }
      })
      return Object.values(unique)
    }
  },
  methods: {
    formatRupiah,
    findByValue(name, kantorId = null) {
      if (kantorId) {
        const item = this.laporan.find(i => i.value === name && i.kantor_id === kantorId)
        return item ? item.total : 0
      } else {
        // jika tidak pilih kantor, jumlahkan semua kantor
        const items = this.laporan.filter(i => i.value === name)
        return items.reduce((sum, i) => sum + i.total, 0)
      }
    },
    hitungTotal() {
      // Fungsi untuk menjumlahkan semua total dari value tertentu (semua kantor)
      const cari = (nama) => {
        const items = this.laporan.filter(i => i.value === nama);
        return items.reduce((sum, i) => sum + (i.total || 0), 0);
      };

      // Hitung per kategori
      const pendapatan = cari('Pembayaran Invoice')
        + cari('Pemasangan baru & instalasi')
        + cari('Pendapatan lain-lain');

      const bebanPokok = cari('Bandwidth Expense') + cari('Equipment');

      const bebanOperasional = [
        'Wage & Salary Expense',
        'Operating Expense',
        'FO Dev Expense',
        'Technical Support',
        'Maintenance Expense',
        'Marketing Fee',
      ].reduce((sum, nama) => sum + cari(nama), 0);

      const lainnya = [
        'Kredit Bank',
        'Tax Expense',
        'Pembayaran Zakat',
        'Pajak penghasilan PPH 23'
      ].reduce((sum, nama) => sum + cari(nama), 0);

      // Simpan ke data total
      this.total.pendapatan = pendapatan;
      this.total.beban_pokok = bebanPokok;
      this.total.beban_operasional = bebanOperasional;
      this.total.laba_kotor = pendapatan - bebanPokok;
      this.total.laba_usaha = pendapatan - bebanPokok - bebanOperasional;
      this.total.laba_bersih = pendapatan - bebanPokok - bebanOperasional - lainnya;
    },

    onFilterChange() {
      this.fetchLabaRugi();
    },
    async fetchLabaRugi() {
      this.loading = true
      try {
        const bulan = this.filter.periode;
        // ✅ Kirim array ID kantor yang dipilih
        const kantorIds = Array.isArray(this.filter.kantor) && this.filter.kantor.length > 0
          ? this.filter.kantor.map(k => k.id).join(',')
          : null;
        const res = await axios.get('api/laporan/laba_rugi', {
          params: {
            periode: bulan,
            kantor_id: kantorIds
          }
        })
        this.laporan = res.data.data || [];
        this.hitungTotal()
      } catch (e) {
        console.error(e)
      } finally {
        this.loading = false
      }
    },
    openModalDetail({ id, item, total, kantor_id }) {
      EventBus.$emit('modal:show', {
        title: `${item}`,
        component: ModalDetaiLabaRugi,
        props: { id, total, periode: this.filter.periode, kantor_id: this.filter.kantor?.id, cabang_id: kantor_id},
        width: '900px',
        key: `${Date.now()}`
      })
    },
  },

  mounted() {
    this.fetchLabaRugi();
  },


}
</script>
<style scoped>
.font-bold {
  font-weight: bold;
  font-size: 18px;
}

.bg-success.bg-opacity-75 {
  background-color: #c8e6c9 !important;
  /* hijau muda */
}
</style>
